(function () {
  var tried = {};

  function data() {
    return window.CHB_OFFER || null;
  }

  function quote(cart) {
    var offer = data();
    var units = [];
    var group = (offer && offer.group) || 3;
    if (offer && cart && cart.items) {
      cart.items.forEach(function (item) {
        var row = offer.variants[String(item.variant_id)];
        if (!row || row.sale) return;
        var each = row.units > 0 ? row.units : 1;
        var unit = Math.round(row.pricePence / each);
        var copies = (item.quantity || 0) * each;
        for (var i = 0; i < copies; i++) units.push(unit);
      });
    }
    units.sort(function (a, b) { return a - b; });
    var total = units.length;
    var rewards = Math.floor(total / group);
    var hasCodes = !!(offer && offer.codes && Object.keys(offer.codes).length);
    var counted = rewards;
    var amount = 0;
    var code = "";
    while (counted > 0) {
      amount = 0;
      for (var n = 0; n < counted; n++) amount += Math.round(units[n] / 2);
      code = hasCodes ? (offer.codes[String(amount)] || "") : "";
      if (code || !hasCodes) break;
      counted -= 1;
    }
    var remainder = total % group;
    var needed = total === 0 ? group : (remainder === 0 ? group : group - remainder);
    var progress = 0;
    if (total > 0) {
      var filled = remainder === 0 ? group : remainder;
      progress = Math.round((filled / group) * 100);
    }
    return {
      units: total,
      rewards: rewards,
      amount: amount,
      needed: needed,
      remainder: remainder,
      group: group,
      code: code,
      progress: progress
    };
  }

  function message(result) {
    var offer = data();
    var copy = (offer && offer.messages) || {};
    if (result.units === 0) return copy.zero || "";
    if (result.rewards === 0 && result.units === 1) return copy.one || "";
    if (result.rewards === 0 && result.units === result.group - 1) return copy.two || "";
    if (result.rewards > 0 && result.needed > 0 && result.needed < result.group) {
      return (copy.next || "").replace("%d", String(result.needed));
    }
    if (result.rewards > 0) return copy.unlocked || "";
    return (copy.next || "").replace("%d", String(result.needed));
  }

  function listed(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return null;
    return cart.discount_codes.map(function (row) {
      return row && row.code ? String(row.code) : "";
    }).filter(Boolean);
  }

  function ours(code) {
    var offer = data();
    var prefix = (offer && offer.prefix) || "c3h";
    return code.indexOf(prefix) === 0;
  }

  function wanted(cart, result) {
    if (result.rewards > 0 && result.code) return [result.code];
    var current = listed(cart);
    if (!current) return [];
    return current.filter(function (code) { return !ours(code); });
  }

  function same(left, right) {
    return left.slice().sort().join("|") === right.slice().sort().join("|");
  }

  function endpoint() {
    var value = window.CHB && window.CHB.cartUpdate;
    if (!value || value.charAt(0) !== "/") return "/cart/update.js";
    return value;
  }

  function post(code) {
    return fetch(endpoint(), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ discount: code })
    }).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok || !body || !Array.isArray(body.items)) throw body;
        return body;
      });
    });
  }

  function sync(cart) {
    var offer = data();
    var result = quote(cart);
    if (!offer) {
      cart.chbOffer = { quote: result, note: "", blocked: "" };
      return Promise.resolve(cart);
    }
    var note = "";
    var current = listed(cart);
    var want = wanted(cart, result);
    if (result.rewards > 0 && result.code && current && current.some(function (code) { return !ours(code); })) {
      note = (offer.messages && offer.messages.blocked) || "";
    }
    function finish(next) {
      next.chbOffer = { quote: quote(next), note: note, blocked: (offer && offer.messages && offer.messages.blocked) || "" };
      window.CHBOffer.current = next.chbOffer.quote;
      window.CHBOffer.current.blocked = next.chbOffer.blocked;
      return next;
    }
    if (!offer || !offer.codes || !Object.keys(offer.codes).length) return Promise.resolve(finish(cart));
    if (current && same(current, want)) return Promise.resolve(finish(cart));
    if (!result.code && result.rewards > 0) return Promise.resolve(finish(cart));
    var target = want.join(",");
    if (!current && !target) return Promise.resolve(finish(cart));
    var signature = (cart.items || []).map(function (item) {
      return item.variant_id + "x" + item.quantity;
    }).join(",") + ">" + target;
    if (!current && tried[signature]) return Promise.resolve(finish(cart));
    tried[signature] = true;
    return post(target).then(finish).catch(function () { return finish(cart); });
  }

  window.CHBOffer = { quote: quote, message: message, sync: sync, current: null };
})();
